"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ({
  hideCloseButton,
  hasHeader
}) => ({
  padding: !hideCloseButton || hasHeader ? 4 : 2,
  fontSize: 'xl',
  fontWeight: 'semibold',
  // If just close button, still have 'header' section at top
  minHeight: hasHeader || hideCloseButton ? null : 12
});
exports.default = _default;